<div class="toast-history-drawer" role="status" aria-live="polite">
  <i [ngClass]="iconClass"></i>
  <span class="range">{{ message }}</span>
</div>
